/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCities } from "malaysia-postcodes";
import SlimSelect from 'slim-select'

const __vue_script__ = {
    props: ["frm", "session_id_prop"],
    data() {
        return {
            session_id: this.session_id_prop,
            error: false,
            support_email_address: "",
            logo_file_path: "",
            formData: {
                doctype: '',
                name: '',
                full_name: '',
                email: '',
                contact_number: '',
                country_iso2: '',
                identification_number_type: 'MyKad',
                identification_number: '',
                tax_id: '',
                roc: '',
                sst_number: '',
                msic_code: '',
                fax_number: '',
                operating_from_time: '',
                operating_to_time: '',
                sales_representative: '',
                sales_representative_email: '',
                sales_representative_contact_number: '',
                sales_representative_country_iso2: '',
                accounts_receivable_representative: '',
                accounts_receivable_representative_email: '',
                accounts_receivable_representative_contact_number: '',
                accounts_receivable_representative_country_iso2: '',
                address_line_1: '',
                address_line_2: '',
                postcode: '',
                city: '',
                state_code: '',
                country: 'Malaysia',
                session_id: this.session_id,
            },
            state_options: [],
            country_options: [],
            msic_options: [],
            slim_select_instance: null,
            identification_number_type_options: [],
            is_submitting: false,
            is_submitted: false,
            is_supplier: false,
            claim_as: "",
            phone_instance: null,
            sales_representative_contact_number_instance: null,
            accounts_receivable_representative_contact_number_instance: null,
            form_error_data: {},
        };
    },
    computed: {
        filtered_state_options() {
            // Filter out "All State" and "Not Applicable"
            return this.state_options.filter(option =>
                // option.state !== 'All States' && option.state !== 'Not Applicable'
                option.name !== "00"
            )
        },
        get_identification_number_placeholder() {
            if (this.formData.identification_number_type === "MyKad") {
                return "Eg: 020712081223";
            } else if (this.formData.identification_number_type === "Passport") {
                return "Eg: A12345678";
            }
            return "Enter Identification Number";
        },
    },
    methods: {
        get_profile() {
            frappe.call({
                method: "myinvois.api.get_profile",
                args: {
                    session_id: this.session_id,
                },
                callback: (response) => {
                    if (response.success) {
                        const response_info = response.message.customer_einvoice_info[0];

                        this.identification_number_type_options = response.message.identification_number_type_options;
                        if (response_info.customer) {
                            this.formData.name = response_info.customer;
                            this.claim_as = response_info.customer_type;
                            this.formData.doctype = "Customer";
                        } else if (response_info.supplier) {
                            this.formData.name = response_info.supplier;
                            this.claim_as = response_info.supplier_type;
                            this.is_supplier = true;
                            this.formData.doctype = "Supplier";
                        }
                        this.logo_file_path = response.message.logo_file_path;

                        if (response_info.docstatus == 0) {
                            this.formData.full_name = response_info.full_name;

                            if (response_info.customer_type == "Company")
                                this.formData.identification_number_type = ""

                        } else if (response_info.docstatus == 1) {
                            if (response_info.customer_type === "Individual" || response_info.supplier_type === "Individual") {
                                this.formData.identification_number_type = response_info.identification_number_type;
                                this.formData.identification_number = response_info.identification_number;

                            } else if (response_info.customer_type === "Company" || response_info.supplier_type === "Company") {
                                this.formData.roc = response_info.business_registration_of_company_number_roc;
                                if (response_info.sales_and_services_tax_sst_registration_number == "") {
                                    this.formData.sst_number = " "
                                } else {
                                    this.formData.sst_number = response_info.sales_and_services_tax_sst_registration_number;
                                }
                                this.formData.msic_code = response_info.msic_code;
                                this.formData.fax_number = response_info.fax_number;
                                this.formData.operating_from_time = this.set_time_format(response_info.operating_from_time);
                                this.formData.operating_to_time = this.set_time_format(response_info.operating_to_time);

                                this.formData.sales_representative = response_info.sales_representative;
                                this.formData.sales_representative_email = response_info.sales_representative_email;
                                this.formData.sales_representative_contact_number = response_info.sales_representative_contact_number;
                                this.formData.accounts_receivable_representative = response_info.accounts_receivable_representative;
                                this.formData.accounts_receivable_representative_email = response_info.accounts_receivable_representative_email;
                                this.formData.accounts_receivable_representative_contact_number = response_info.accounts_receivable_representative_contact_number;

                                const sales_representative_contact_number_country = this.sales_representative_contact_number_instance.getSelectedCountryData(response_info.sales_representative_country_iso2);
                                const sales_representative_contact_number_dial_code = `+${sales_representative_contact_number_country.dialCode}`;
                                const sales_representative_contact_number = document.querySelector("#sales_representative_contact_number");
                                sales_representative_contact_number.value = response_info.sales_representative_contact_number.slice(sales_representative_contact_number_dial_code.length);

                                this.sales_representative_contact_number_instance.setCountry(response_info.sales_representative_country_iso2);

                                const accounts_receivable_representative_contact_number_country = this.accounts_receivable_representative_contact_number_instance.getSelectedCountryData(response_info.accounts_receivable_representative_country_iso2);
                                const accounts_receivable_representative_contact_number_dial_code = `+${accounts_receivable_representative_contact_number_country.dialCode}`;
                                const accounts_receivable_representative_contact_number = document.querySelector("#accounts_receivable_representative_contact_number");
                                accounts_receivable_representative_contact_number.value = response_info.accounts_receivable_representative_contact_number.slice(accounts_receivable_representative_contact_number_dial_code.length);

                                this.accounts_receivable_representative_contact_number_instance.setCountry(response_info.accounts_receivable_representative_country_iso2);
                            }
                            this.formData.full_name = response_info.full_name;
                            this.formData.email = response_info.email;
                            this.formData.contact_number = response_info.contact_number;

                            this.phone_instance.setCountry(response_info.country_iso2);

                            const country = this.phone_instance.getSelectedCountryData(response_info.country_iso2);
                            const dial_code = `+${country.dialCode}`;
                            const phone_input = document.querySelector("#phone");
                            phone_input.value = response_info.contact_number.slice(dial_code.length);

                            this.phone_instance.setCountry(response_info.country_iso2);

                            this.formData.tax_id = response_info.tax_id;
                            this.formData.address_line_1 = response_info.address_line_1;
                            this.formData.address_line_2 = response_info.address_line_2;
                            this.formData.postcode = response_info.postcode;
                            this.formData.city = response_info.city;
                            this.formData.state_code = response_info.state_code;

                            this.is_submitted = true;
                        }
                    } else {
                        this.error = true;
                        this.support_email_address = response.message.support_email_address;
                    }
                }
            });
        },
        set_time_format(time_string) {
            const [hours, minutes] = time_string.split(':').map((part) => parseInt(part, 10) || 0);

            // Pad hours and minutes to always have two digits
            const formatted_hours = hours.toString().padStart(2, '0');
            const formatted_minutes = minutes.toString().padStart(2, '0');

            return `${formatted_hours}:${formatted_minutes}`;
        },
        get_msic_codes() {
            frappe.call({
                method: "myinvois.api.get_msic_codes",
                args: {},
                callback: (response) => {
                    if (response.message) {
                        this.msic_options = response.message;
                        this.$nextTick(() => {
                            if (this.slim_select_instance) {
                                this.slim_select_instance.destroy();
                            }
                            this.slim_select_instance = new SlimSelect({
                                select: '#msic-code-select-element',
                            });
                        });
                    }
                }
            });
        },
        get_country_and_state_codes() {
            frappe.call({
                method: "myinvois.api.get_country_and_state_codes",
                args: {},
                callback: (response) => {
                    if (response.message) {
                        this.state_options = response.message.state_codes;
                        this.country_options = response.message.countries;
                    }
                }
            });
        },
        set_cities(state) {
            const matched_state = this.state_options.find(state_dict => state_dict.name === state)

            if (matched_state.state === 'Wilayah Persekutuan Kuala Lumpur')
                return ["Kuala Lumpur"]
            else if (matched_state.state === 'Wilayah Persekutuan Labuan')
                return ["Labuan"]
            else if (matched_state.state === 'Pulau Pinang')
                matched_state.state = "Penang";
            else if (matched_state.state === 'Wilayah Persekutuan Putrajaya')
                return ["Putrajaya"]
            return getCities(matched_state.state)
        },
        validate_form() {
            let isValid = true;
            this.form_error_data = {}; // Clear previous errors

            const form_container = document.querySelector(".form-container");
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            const nricPattern = /^\d{6}\d{2}\d{4}$/;
            const passportPattern = /^[AHKahk]\d{8}$/;
            const taxIDPatternIndividual = /^(IG)(\d{9,11})$/; // Individual TINs
            const taxIDPatternCompany = /^[CDEF](\d{9,11})(0?)$/;  // Non-Individual TINs

            const rocPattern = /^\d{4}(01|02|03|04|05|06)\d{6}$/;
            const sstRegNoPattern = /^[A-Z]\d{2}\d{4}\d{8}$/;

            const email_input = document.querySelector("#email-field");
            const sales_representative_email_input = document.querySelector("#sales_representative_email")
            const accounts_receivable_representative_email_input = document.querySelector("#accounts_receivable_representative_email")

            const phone_input = document.querySelector("#phone");
            const sales_representative_contact_number_input = document.querySelector("#sales_representative_contact_number");
            const accounts_receivable_representative_contact_number_input = document.querySelector("#accounts_receivable_representative_contact_number");

            const identification_number_input = document.querySelector("#identification_number");
            const tax_id_input = document.querySelector("#tax_id");
            const roc_input = document.querySelector("#roc");
            const sst_number_input = document.querySelector("#sst_number");

            const identification_number_patterns = {
                'MyKad': nricPattern,
                'Passport': passportPattern,
            };

            // if (!this.formData.tax_id || this.formData.tax_id === null || !taxIDPatternIndividual.test(this.formData.tax_id)) {
            //     this.form_error_data.tax_id = "Please enter a valid TIN.";
            //     isValid = false;
            //     tax_id_input.style.borderColor = "red";
            // } else {
            //     tax_id_input.style.borderColor = "";
            // }

            // Email Validation
            if (!this.formData.email || !emailPattern.test(this.formData.email)) {
                this.form_error_data.email = "Please enter a valid email address.";
                isValid = false;
                email_input.style.borderColor = "red";
            } else {
                email_input.style.borderColor = "";
            }

            // Phone Validation
            if (!this.phone_instance) {
                if (!phone_input.value) {
                    this.form_error_data.phone = "Please enter a phone number.";
                    isValid = false;
                    phone_input.style.borderColor = "red";
                } else {
                    phone_input.style.borderColor = "";
                }

            } else {
                const isValidPhone = this.phone_instance.isValidNumber();
                if (!isValidPhone) {
                    this.form_error_data.phone = "Please enter a valid phone number.";
                    isValid = false;
                    phone_input.style.borderColor = "red";
                } else {
                    phone_input.style.borderColor = "";
                }
            }

            if (this.claim_as == "Individual") {
                if (this.formData.identification_number_type) {
                    // Identification Number
                    if (identification_number_input) {
                        const value = this.formData.identification_number;
                        const pattern = identification_number_patterns[this.formData.identification_number_type];
                        if (!value || value === null || !pattern.test(value)) {
                            this.form_error_data.identification_number = `Please enter a valid ${this.formData.identification_number_type} number.`;
                            isValid = false;
                            identification_number_input.style.borderColor = "red";
                        } else {
                            identification_number_input.style.borderColor = "";
                        }
                    }
                }

                if (!taxIDPatternIndividual.test(this.formData.tax_id)) {
                    this.form_error_data.tax_id = "Please enter a valid TIN for an Individual.";
                    isValid = false;
                    tax_id_input.style.borderColor = "red";
                } else {
                    tax_id_input.style.borderColor = "";
                }

            } else if (this.claim_as == "Company") {
                if (!taxIDPatternCompany.test(this.formData.tax_id)) {
                    this.form_error_data.tax_id = "Please enter a valid TIN for a Company.";
                    isValid = false;
                    tax_id_input.style.borderColor = "red";
                } else {
                    tax_id_input.style.borderColor = "";
                }

                // Company ROC/BRN
                if (!this.formData.roc || this.formData.roc === null || !rocPattern.test(this.formData.roc)) {
                    this.form_error_data.roc = "Please enter a valid ROC.";
                    isValid = false;
                    roc_input.style.borderColor = "red";
                } else {
                    roc_input.style.borderColor = "";
                }

                // SST Registration No
                if (this.formData.sst_number != "" && !sstRegNoPattern.test(this.formData.sst_number)) {
                    this.form_error_data.sst_number = "Please enter a valid SST Registration No.";
                    isValid = false;
                    sst_number_input.style.borderColor = "red";
                } else {
                    sst_number_input.style.borderColor = "";
                }

                // Sales Representative Email Validation
                if (!this.formData.sales_representative_email || !emailPattern.test(this.formData.sales_representative_email)) {
                    this.form_error_data.sales_representative_email = "Please enter a valid email address.";
                    isValid = false;
                    sales_representative_email_input.style.borderColor = "red";
                } else {
                    sales_representative_email_input.style.borderColor = "";
                }

                // Sales Representative Contact Number Validation
                if (!this.sales_representative_contact_number_instance) {
                    if (!sales_representative_contact_number_input.value) {
                        this.form_error_data.sales_representative_contact_number = "Please enter a contact number.";
                        isValid = false;
                        sales_representative_contact_number_input.style.borderColor = "red";
                    } else {
                        sales_representative_contact_number_input.style.borderColor = "";
                    }
                } else {
                    const isValidSalesPhone = this.sales_representative_contact_number_instance.isValidNumber();
                    if (!isValidSalesPhone) {
                        this.form_error_data.sales_representative_contact_number = "Please enter a valid contact number.";
                        isValid = false;
                        sales_representative_contact_number_input.style.borderColor = "red";
                    } else {
                        sales_representative_contact_number_input.style.borderColor = "";
                    }
                }

                // Account Receivable Representative Email Validation
                if (!this.formData.accounts_receivable_representative_email || !emailPattern.test(this.formData.accounts_receivable_representative_email)) {
                    this.form_error_data.accounts_receivable_representative_email = "Please enter a valid email address.";
                    isValid = false;
                    accounts_receivable_representative_email_input.style.borderColor = "red";
                } else {
                    accounts_receivable_representative_email_input.style.borderColor = "";
                }

                // Account Receivable Representative Contact Number Validation
                if (!this.accounts_receivable_representative_contact_number_instance) {
                    if (!accounts_receivable_representative_contact_number_input.value) {
                        this.form_error_data.accounts_receivable_representative_contact_number = "Please enter an contact number.";
                        isValid = false;
                        accounts_receivable_representative_contact_number_input.style.borderColor = "red";
                    } else {
                        accounts_receivable_representative_contact_number_input.style.borderColor = "";
                    }
                } else {
                    const isValidAccountPhone = this.accounts_receivable_representative_contact_number_instance.isValidNumber();
                    if (!isValidAccountPhone) {
                        this.form_error_data.accounts_receivable_representative_contact_number = "Please enter a valid contact number.";
                        isValid = false;
                        accounts_receivable_representative_contact_number_input.style.borderColor = "red";
                    } else {
                        accounts_receivable_representative_contact_number_input.style.borderColor = "";
                    }
                }
            }
            if (!isValid) {
                form_container.style.border = "2px solid red";
            } else {
                form_container.style.border = ""
            }

            return isValid;
        },
        init_phone_input() {
            const phone_input = document.querySelector("#phone");
            const sales_representative_contact_number = document.querySelector("#sales_representative_contact_number");
            const accounts_receivable_representative_contact_number = document.querySelector("#accounts_receivable_representative_contact_number");

            if (phone_input) {
                this.phone_instance = intlTelInput(phone_input, {
                    initialCountry: "my",
                    loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js"),
                    separateDialCode: true,
                    useFullscreenPopup: false,
                    autoPlaceholder: "aggressive",
                    validationNumberTypes: ["FIXED_LINE_OR_MOBILE"]
                });

                phone_input.addEventListener("input", () => this.update_phone_number("phone"));
                phone_input.addEventListener("countrychange", () => this.update_phone_number("phone"));
            }

            if (sales_representative_contact_number) {
                this.sales_representative_contact_number_instance = intlTelInput(sales_representative_contact_number, {
                    initialCountry: "my",
                    loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js"),
                    separateDialCode: true,
                    useFullscreenPopup: false,
                    autoPlaceholder: "aggressive",
                    validationNumberTypes: ["FIXED_LINE_OR_MOBILE"]
                });
                sales_representative_contact_number.addEventListener("input", () => this.update_phone_number("sales_phone"));
                sales_representative_contact_number.addEventListener("countrychange", () => this.update_phone_number("sales_phone"));
            }

            if (accounts_receivable_representative_contact_number) {
                this.accounts_receivable_representative_contact_number_instance = intlTelInput(accounts_receivable_representative_contact_number, {
                    initialCountry: "my",
                    loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js"),
                    separateDialCode: true,
                    useFullscreenPopup: false,
                    autoPlaceholder: "aggressive",
                    validationNumberTypes: ["FIXED_LINE_OR_MOBILE"]
                });
                accounts_receivable_representative_contact_number.addEventListener("input", () => this.update_phone_number("account_phone"));
                accounts_receivable_representative_contact_number.addEventListener("countrychange", () => this.update_phone_number("account_phone"));
            }
        },
        update_phone_number(type) {
            if (type === "phone" && this.phone_instance) {
                const formatted_number = this.phone_instance.getNumber();
                const country_iso2 = this.phone_instance.getSelectedCountryData().iso2;
                const is_valid = this.phone_instance.isValidNumber();

                if (is_valid !== false) {
                    this.formData.contact_number = formatted_number;
                    this.formData.country_iso2 = country_iso2;
                }
            } else if (type === "sales_phone" && this.sales_representative_contact_number_instance) {
                const formatted_number = this.sales_representative_contact_number_instance.getNumber();
                const sales_representative_country_iso2 = this.sales_representative_contact_number_instance.getSelectedCountryData().iso2;
                const is_valid = this.sales_representative_contact_number_instance.isValidNumber();

                if (is_valid !== false) {
                    this.formData.sales_representative_contact_number = formatted_number;
                    this.formData.sales_representative_country_iso2 = sales_representative_country_iso2;
                }
            } else if (type === "account_phone" && this.accounts_receivable_representative_contact_number_instance) {
                const formatted_number = this.accounts_receivable_representative_contact_number_instance.getNumber();
                const accounts_receivable_representative_country_iso2 = this.accounts_receivable_representative_contact_number_instance.getSelectedCountryData().iso2;
                const is_valid = this.accounts_receivable_representative_contact_number_instance.isValidNumber();

                if (is_valid !== false) {
                    this.formData.accounts_receivable_representative_contact_number = formatted_number;
                    this.formData.accounts_receivable_representative_country_iso2 = accounts_receivable_representative_country_iso2;
                }
            }
        },
        submit_form() {
            if (this.is_submitting || this.is_submitted)
                return;

            const isValid = this.validate_form();
            if (!isValid)
                return;

            this.update_phone_number();

            this.is_submitting = true;
            frappe.call({
                method: "myinvois.api.submit_profile",
                args: { formData: this.formData },
                callback: (response) => {
                    this.is_submitting = false;

                    if (response.success) {
                        this.is_submitted = true;
                        frappe.show_alert({
                            title: "Success",
                            indicator: "green",
                            message: "Data submitted successfully.",
                        });
                    } else {
                        frappe.msgprint({
                            title: "Invalid",
                            indicator: "red",
                            message: response.message,
                        });
                    }
                },
                error: () => {
                    this.is_submitting = false;
                },
            });
        },
        handleKeydown(event) {
            const allowedKeyCodes = [
                48, 49, 50, 51, 52, 53, 54, 55, 56, 57, // Regular digits (0-9)
                96, 97, 98, 99, 100, 101, 102, 103, 104, 105, // Numpad digits (0-9)
                13, // Enter key
                8, // Backspace key
                9, // Tab key
                37, // Left arrow key
                39, // Right arrow key
                46, // Delete key
                65, // Ctrl+A
                88, // Ctrl+X
                67, // Ctrl+C
                86 // Ctrl+V
            ];

            if (event.type === 'keydown') {
                if (
                    allowedKeyCodes.includes(event.keyCode) ||
                    (event.ctrlKey && ["a", "x", "c", "v"].includes(event.key))
                ) {
                    return true;
                } else {
                    event.preventDefault();
                    return false;
                }
            }
        },
        handleInput(event) {
            const inputValue = event.target.value;
            const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
            this.formData.identification_number = sanitizedValue;

            event.target.value = sanitizedValue;
        },
    },
    watch: {
        'formData.identification_number_type'(new_value, old_value) {
            if (new_value !== old_value) {
                this.formData.identification_number = '';
            }
        },
        "formData.country"(new_country) {
            if (new_country !== "Malaysia") {
                this.formData.state_code = "17";
                this.formData.city = null;
            } else {
                this.formData.state_code = null;
                this.formData.city = null;
            }
        },
        claim_as(newValue) {
            if (newValue === "Company") {
                this.$nextTick(() => {
                    this.init_phone_input();
                    this.get_profile();
                });
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.get_profile();
            this.init_phone_input();
            this.get_msic_codes();
            this.get_country_and_state_codes();
        });
    },
    beforeUnmount() {
        if (this.phone_instance) {
            this.phone_instance.destroy();
        }
        if (this.sales_representative_contact_number_instance) {
            this.sales_representative_contact_number_instance.destroy();
        }
        if (this.accounts_receivable_representative_contact_number_instance) {
            this.accounts_receivable_representative_contact_number_instance.destroy();
        }
    }
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.error
    ? _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center",
            "margin-top": "10rem"
          }
        },
        [
          _c("img", {
            staticStyle: { width: "40rem", margin: "1rem" },
            attrs: {
              src: "/assets/myinvois/images/Error Page Image.png",
              alt: "Logo"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "error-box" }, [
            _c("p", { staticStyle: { "margin-bottom": "0" } }, [
              _vm._v("Invalid session link."),
              _c("br"),
              _vm._v("If you have any concern, please contact us at "),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _c(
                  "a",
                  { attrs: { href: "mailto:" + _vm.support_email_address } },
                  [_vm._v(_vm._s(_vm.support_email_address))]
                )
              ])
            ])
          ])
        ]
      )
    : _c("div", [
        _c("div", { staticClass: "header-container" }, [
          _c("img", {
            staticStyle: { width: "9rem", margin: "1rem" },
            attrs: { src: _vm.logo_file_path, alt: "Logo" }
          }),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-container" }, [
          _vm.is_submitted
            ? _c(
                "div",
                {
                  staticClass: "rounded",
                  staticStyle: { "background-color": "#e4e4e4" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "margin-top": "20px"
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "40px",
                            height: "40px",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: "0.5",
                              d:
                                "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
                              fill: "#008000"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z",
                              fill: "#ffffff"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "font-size": "14px",
                        "font-weight": "bold",
                        "justify-content": "center",
                        margin: "8px"
                      }
                    },
                    [
                      _vm._v(
                        "\n                Congratulations! Your E-Invoice Info has been successfully submitted.\n            "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit_form.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-weight": "bold",
                    color: "black",
                    padding: "1rem 0 0 0"
                  }
                },
                [
                  _vm.claim_as === "Company"
                    ? _c("span", [_vm._v("COMPANY DETAILS")])
                    : _c("span", [_vm._v("INDIVIDUAL DETAILS")])
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "title-line" }),
              _vm._v(" "),
              _vm.claim_as === "Individual"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "identification-number-row" },
                      _vm._l(_vm.identification_number_type_options, function(
                        identification_number_type
                      ) {
                        return _c(
                          "div",
                          {
                            key: identification_number_type,
                            staticClass: "form-check"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.formData.identification_number_type,
                                  expression:
                                    "formData.identification_number_type"
                                }
                              ],
                              attrs: {
                                type: "radio",
                                id: identification_number_type,
                                required: "",
                                disabled: _vm.is_submitted
                              },
                              domProps: {
                                value: identification_number_type,
                                checked: _vm._q(
                                  _vm.formData.identification_number_type,
                                  identification_number_type
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.formData,
                                    "identification_number_type",
                                    identification_number_type
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", {
                              staticStyle: { margin: "0 1rem 0 0" },
                              attrs: { for: identification_number_type },
                              domProps: {
                                textContent: _vm._s(identification_number_type)
                              }
                            })
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Individual"
                ? _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.identification_number,
                          expression: "formData.identification_number"
                        }
                      ],
                      attrs: {
                        type: "text",
                        pattern: "[0-9]*",
                        id: "identification_number",
                        placeholder: _vm.get_identification_number_placeholder,
                        required: "",
                        disabled: _vm.is_submitted
                      },
                      domProps: { value: _vm.formData.identification_number },
                      on: {
                        keydown: _vm.handleKeydown,
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.formData,
                              "identification_number",
                              $event.target.value
                            )
                          },
                          _vm.handleInput
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-error-msg" }, [
                      _vm.form_error_data.identification_number
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.form_error_data.identification_number)
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "full_name" } }, [
                  _vm.claim_as === "Company"
                    ? _c("span", [_vm._v("Company Name")])
                    : _c("span", [_vm._v("Full Name (as per ID)")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.full_name,
                      expression: "formData.full_name"
                    }
                  ],
                  attrs: { type: "text", disabled: _vm.is_submitted },
                  domProps: { value: _vm.formData.full_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "full_name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "email" } }, [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.claim_as === "Company"
                          ? "Company Email Address"
                          : "Email Address"
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.email,
                      expression: "formData.email"
                    }
                  ],
                  attrs: {
                    type: "email",
                    id: "email-field",
                    placeholder:
                      _vm.claim_as === "Company"
                        ? "company@domain.com"
                        : "email@domain.com",
                    disabled: _vm.is_submitted
                  },
                  domProps: { value: _vm.formData.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "email", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-error-msg" }, [
                  _vm.form_error_data.email
                    ? _c("span", [_vm._v(_vm._s(_vm.form_error_data.email))])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "contact_number" } }, [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.claim_as === "Company"
                          ? "Company Contact No."
                          : "Contact No."
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
                ]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    id: "phone",
                    type: "tel",
                    disabled: _vm.is_submitted
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-error-msg" }, [
                  _vm.form_error_data.phone
                    ? _c("span", [_vm._v(_vm._s(_vm.form_error_data.phone))])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "tax_id" } }, [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.claim_as === "Company"
                          ? "Company Tax Identification No. (TIN)"
                          : "Tax Identification No. (TIN)"
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.tax_id,
                      expression: "formData.tax_id"
                    }
                  ],
                  attrs: {
                    id: "tax_id",
                    type: "text",
                    placeholder: "Eg: CXX53644000",
                    required: "",
                    disabled: _vm.is_submitted
                  },
                  domProps: { value: _vm.formData.tax_id },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.formData, "tax_id", $event.target.value)
                      },
                      function($event) {
                        _vm.formData.tax_id = _vm.formData.tax_id.toUpperCase()
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-error-msg" }, [
                  _vm.form_error_data.tax_id
                    ? _c("span", [_vm._v(_vm._s(_vm.form_error_data.tax_id))])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.roc,
                          expression: "formData.roc"
                        }
                      ],
                      attrs: {
                        id: "roc",
                        type: "text",
                        placeholder: "Eg: 198301031144",
                        required: "",
                        disabled: _vm.is_submitted
                      },
                      domProps: { value: _vm.formData.roc },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.formData, "roc", $event.target.value)
                          },
                          function($event) {
                            _vm.formData.roc = _vm.formData.roc.toUpperCase()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-error-msg" }, [
                      _vm.form_error_data.roc
                        ? _c("span", [_vm._v(_vm._s(_vm.form_error_data.roc))])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.sst_number,
                          expression: "formData.sst_number"
                        }
                      ],
                      attrs: {
                        id: "sst_number",
                        type: "text",
                        placeholder: "Eg: XXX8888888888XX",
                        disabled: _vm.is_submitted
                      },
                      domProps: { value: _vm.formData.sst_number },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.formData,
                              "sst_number",
                              $event.target.value
                            )
                          },
                          function($event) {
                            _vm.formData.sst_number = _vm.formData.sst_number.toUpperCase()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-error-msg" }, [
                      _vm.form_error_data.sst_number
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.form_error_data.sst_number))
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company" && _vm.is_supplier
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData.msic_code,
                            expression: "formData.msic_code"
                          }
                        ],
                        attrs: {
                          required: "",
                          disabled: _vm.is_submitted,
                          id: "msic-code-select-element"
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.formData,
                              "msic_code",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.msic_options, function(msic_code, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: msic_code.name } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(msic_code.name) +
                                " - " +
                                _vm._s(msic_code.description) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.fax_number,
                          expression: "formData.fax_number"
                        }
                      ],
                      attrs: {
                        type: "text",
                        placeholder: "Eg: 123-456-7890",
                        disabled: _vm.is_submitted
                      },
                      domProps: { value: _vm.formData.fax_number },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "fax_number",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(6),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.operating_from_time,
                          expression: "formData.operating_from_time"
                        }
                      ],
                      attrs: {
                        type: "time",
                        required: "",
                        disabled: _vm.is_submitted
                      },
                      domProps: { value: _vm.formData.operating_from_time },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "operating_from_time",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.operating_to_time,
                          expression: "formData.operating_to_time"
                        }
                      ],
                      attrs: {
                        type: "time",
                        required: "",
                        disabled: _vm.is_submitted
                      },
                      domProps: { value: _vm.formData.operating_to_time },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "operating_to_time",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "font-weight": "bold",
                        color: "black",
                        padding: "1rem 0 0 0"
                      }
                    },
                    [_c("span", [_vm._v("Sales Representative Info")])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("hr", { staticClass: "title-line" })
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.sales_representative,
                          expression: "formData.sales_representative"
                        }
                      ],
                      attrs: {
                        type: "text",
                        placeholder: "Eg: John Doe",
                        required: "",
                        disabled: _vm.is_submitted
                      },
                      domProps: { value: _vm.formData.sales_representative },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "sales_representative",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.sales_representative_email,
                          expression: "formData.sales_representative_email"
                        }
                      ],
                      attrs: {
                        type: "text",
                        id: "sales_representative_email",
                        placeholder: "Eg: john.doe@example.com",
                        required: "",
                        disabled: _vm.is_submitted
                      },
                      domProps: {
                        value: _vm.formData.sales_representative_email
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "sales_representative_email",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-error-msg" }, [
                      _vm.form_error_data.sales_representative_email
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form_error_data.sales_representative_email
                              )
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(10),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        id: "sales_representative_contact_number",
                        type: "tel",
                        disabled: _vm.is_submitted
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-error-msg" }, [
                      _vm.form_error_data.sales_representative_contact_number
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form_error_data
                                  .sales_representative_contact_number
                              )
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "font-weight": "bold",
                        color: "black",
                        padding: "1rem 0 0 0"
                      }
                    },
                    [
                      _c("span", [
                        _vm._v("Accounts Receivable Representative Info")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("hr", { staticClass: "title-line" })
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.formData.accounts_receivable_representative,
                          expression:
                            "formData.accounts_receivable_representative"
                        }
                      ],
                      attrs: {
                        type: "text",
                        placeholder: "Eg: Jane Doe",
                        required: "",
                        disabled: _vm.is_submitted
                      },
                      domProps: {
                        value: _vm.formData.accounts_receivable_representative
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "accounts_receivable_representative",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(12),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.formData
                              .accounts_receivable_representative_email,
                          expression:
                            "formData.accounts_receivable_representative_email"
                        }
                      ],
                      attrs: {
                        type: "text",
                        id: "accounts_receivable_representative_email",
                        placeholder: "Eg: jane.doe@example.com",
                        required: "",
                        disabled: _vm.is_submitted
                      },
                      domProps: {
                        value:
                          _vm.formData.accounts_receivable_representative_email
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "accounts_receivable_representative_email",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-error-msg" }, [
                      _vm.form_error_data
                        .accounts_receivable_representative_email
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form_error_data
                                  .accounts_receivable_representative_email
                              )
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.claim_as === "Company"
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(13),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        id: "accounts_receivable_representative_contact_number",
                        type: "tel",
                        disabled: _vm.is_submitted
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-error-msg" }, [
                      _vm.form_error_data
                        .accounts_receivable_representative_contact_number
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form_error_data
                                  .accounts_receivable_representative_contact_number
                              )
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-weight": "bold",
                    color: "black",
                    padding: "1rem 0 0 0"
                  }
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.claim_as === "Company"
                          ? "COMPANY ADDRESS"
                          : "ADDRESS"
                      )
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "title-line" }),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(14),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.address_line_1,
                      expression: "formData.address_line_1"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "NO 123, Jalan Besar",
                    required: "",
                    disabled: _vm.is_submitted
                  },
                  domProps: { value: _vm.formData.address_line_1 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formData,
                        "address_line_1",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(15),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.address_line_2,
                      expression: "formData.address_line_2"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: _vm.is_submitted ? "" : "Apartment 5A",
                    disabled: _vm.is_submitted
                  },
                  domProps: { value: _vm.formData.address_line_2 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formData,
                        "address_line_2",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(16),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.postcode,
                      expression: "formData.postcode"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "12345",
                    required: "",
                    disabled: _vm.is_submitted
                  },
                  domProps: { value: _vm.formData.postcode },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "postcode", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(17),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.country,
                        expression: "formData.country"
                      }
                    ],
                    attrs: { required: "", disabled: _vm.is_submitted },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.formData,
                          "country",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.country_options, function(country) {
                    return _c(
                      "option",
                      { key: country.name, domProps: { value: country.name } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(country.name) +
                            "\n                    "
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(18),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.state_code,
                        expression: "formData.state_code"
                      }
                    ],
                    attrs: {
                      required: "",
                      disabled:
                        _vm.is_submitted || _vm.formData.country != "Malaysia"
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.formData,
                          "state_code",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.filtered_state_options, function(state_code) {
                    return _c(
                      "option",
                      {
                        key: state_code.name,
                        domProps: { value: state_code.name }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(state_code.name) +
                            " - " +
                            _vm._s(state_code.state) +
                            "\n                    "
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(19),
                _vm._v(" "),
                _vm.formData.country != "Malaysia"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.city,
                          expression: "formData.city"
                        }
                      ],
                      attrs: {
                        type: "text",
                        placeholder: "Enter city",
                        required: "",
                        disabled: _vm.is_submitted
                      },
                      domProps: { value: _vm.formData.city },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.formData, "city", $event.target.value)
                        }
                      }
                    })
                  : _vm.formData.state_code
                  ? _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData.city,
                            expression: "formData.city"
                          }
                        ],
                        attrs: { required: "", disabled: _vm.is_submitted },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.formData,
                              "city",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.set_cities(_vm.formData.state_code), function(
                        city,
                        index
                      ) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: city } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(city) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _c("select", [
                      _c("option", { attrs: { disabled: "" } }, [
                        _vm._v("Please Choose State First")
                      ])
                    ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-primary",
                    class: { "btn-success": _vm.is_submitted },
                    staticStyle: {
                      "border-radius": "2rem",
                      "font-weight": "bold"
                    },
                    attrs: {
                      type: "submit",
                      disabled: _vm.is_submitting || _vm.is_submitted
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.is_submitted
                            ? "Submitted"
                            : _vm.is_submitting
                            ? "Submitting..."
                            : "Submit"
                        ) +
                        "\n                "
                    )
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                "margin-top": "2rem",
                color: "#398bff",
                "font-size": "14px"
              }
            },
            [
              _vm._v("\n            Powered by "),
              _c(
                "a",
                {
                  staticStyle: { color: "#398bff" },
                  attrs: {
                    href: "https://www.byondwave.com/",
                    target: "_blank"
                  }
                },
                [_vm._v("BYONDWAVE.com")]
              )
            ]
          )
        ])
      ])
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _vm._v("Complete Details for "),
      _c("br", { staticClass: "mobile-next" }),
      _vm._v(" E-Invoicing Compliances\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticStyle: { "margin-bottom": "1rem" },
        attrs: { for: "identification_number_type" }
      },
      [
        _vm._v(
          "\n                    Identification Number Type\n                    "
        ),
        _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "roc" } }, [
      _vm._v(
        "\n                    New Business Registration No. (ROC)\n                    "
      ),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "sst_number" } }, [
      _vm._v(
        "\n                    Sales and Services Tax (SST) Registration No.\n                    "
      ),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" (Optional)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "msic_code" } }, [
      _vm._v("\n                    MSIC Code\n                    "),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "fax_number" } }, [
      _vm._v("\n                    Fax No.\n                    "),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" (Optional)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "operating_from_time" } }, [
      _vm._v("\n                    Operating From Time\n                    "),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "operating_to_time" } }, [
      _vm._v("\n                    Operating To Time\n                    "),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "sales_representative" } }, [
      _vm._v(
        "\n                    Sales Representative Name\n                    "
      ),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "sales_representative_email" } }, [
      _vm._v(
        "\n                    Sales Representative Email\n                    "
      ),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { attrs: { for: "sales_representative_contact_number" } },
      [
        _vm._v(
          "\n                    Sales Representative Contact No.\n                    "
        ),
        _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { attrs: { for: "accounts_receivable_representative" } },
      [
        _vm._v(
          "\n                    Accounts Receivable Representative Name\n                    "
        ),
        _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { attrs: { for: "accounts_receivable_representative_email" } },
      [
        _vm._v(
          "\n                    Accounts Receivable Representative Email\n                    "
        ),
        _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { attrs: { for: "accounts_receivable_representative_contact_number" } },
      [
        _vm._v(
          "\n                    Accounts Receivable Representative Contact No.\n                    "
        ),
        _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "address_line_1" } }, [
      _c("span", [_vm._v("Address Line 1")]),
      _vm._v(" "),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "address_line_2" } }, [
      _c("span", [_vm._v("Address Line 2")]),
      _vm._v(" "),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" (Optional)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "postcode" } }, [
      _c("span", [_vm._v("Postcode")]),
      _vm._v(" "),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "country" } }, [
      _c("span", [_vm._v("Country")]),
      _vm._v(" "),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "state" } }, [
      _c("span", [_vm._v("State")]),
      _vm._v(" "),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "city" } }, [
      _c("span", [_vm._v("City")]),
      _vm._v(" "),
      _c("span", { staticClass: "mandatory-label" }, [_vm._v(" *")])
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1b940184_0", { source: "\n.header-container[data-v-1b940184] {\n    text-align: center;\n    background-color: #3663e6;\n    padding: 20px;\n    max-width: 500px;\n    margin: 3rem auto 0 auto;\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n}\nh4[data-v-1b940184] {\n    color: white;\n    margin-top: 1.2rem;\n    margin-bottom: 0.5rem;\n    font-weight: bold;\n}\n.form-container[data-v-1b940184] {\n    background: white;\n    padding: 20px 50px;\n    max-width: 500px;\n    margin: 0rem auto 3rem auto;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    border-bottom-left-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n}\n.form-group[data-v-1b940184] {\n    margin-bottom: 20px;\n}\nlabel[data-v-1b940184] {\n    font-weight: 600;\n    display: block;\n    margin-bottom: 8px;\n    color: #555;\n}\ninput[data-v-1b940184] {\n    border-radius: 10px !important;\n}\ninput[data-v-1b940184],\nselect[data-v-1b940184] {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    font-size: 14px;\n    transition: border-color 0.2s ease;\n    background-color: white;\n    color: black;\n}\ninput[data-v-1b940184]:focus,\nselect[data-v-1b940184]:focus {\n    border-color: #007bff;\n    outline: none;\n}\ninput[type=radio][data-v-1b940184] {\n    padding: 0;\n    border: none;\n}\n.form-actions[data-v-1b940184] {\n    text-align: center;\n}\n.btn-primary[data-v-1b940184] {\n    background-color: #007bff;\n    border: none;\n    color: white;\n    padding: 10px 20px;\n    font-size: 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n.btn-primary[data-v-1b940184]:hover {\n    background-color: #0056b3;\n}\n.example-text[data-v-1b940184] {\n    color: #93999c;\n    margin-bottom: 5px;\n    font-size: 14px;\n}\n.mobile-next[data-v-1b940184] {\n    display: none;\n}\n.error-box[data-v-1b940184] {\n    background-color: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n    border-radius: 5px;\n    margin: 0 2rem;\n    padding: 20px;\n    font-size: 16px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.mandatory-label[data-v-1b940184] {\n    color: red;\n}\n.search-input[data-v-1b940184] {\n    margin-bottom: 10px;\n    width: 100%;\n    padding: 8px;\n    box-sizing: border-box;\n}\n.btn-success[data-v-1b940184] {\n    background-color: #28a745;\n    color: white;\n    border-color: #28a745;\n}\n.identification-number-row[data-v-1b940184] {\n    display: flex;\n    align-items: center;\n}\n.form-check[data-v-1b940184] {\n    padding: 0;\n    display: flex;\n    align-items: center;\n}\n.title-line[data-v-1b940184] {\n    border-width: 2px;\n    margin-top: 0.8rem;\n    background: black;\n}\n.form-error-msg[data-v-1b940184] {\n    margin-top: 0.3rem;\n    padding-left: 0.2rem;\n    color: red;\n    font-size: 14px;\n}\n@media (max-width: 575.99px) {\n.header-container[data-v-1b940184] {\n        margin: 1rem 2rem 0 2rem;\n}\n.form-container[data-v-1b940184] {\n        font-size: 0.875rem;\n        margin: 0rem 2rem 1rem 2rem;\n        padding: 20px;\n}\n.mobile-next[data-v-1b940184] {\n        display: block;\n}\nh4[data-v-1b940184] {\n        font-size: 1.5rem;\n}\n}\n", map: {"version":3,"sources":["../myinvois/myinvois/public/js/einvoice_profile/Home.vue"],"names":[],"mappings":";AA67BA;IACA,kBAAA;IACA,yBAAA;IACA,aAAA;IACA,gBAAA;IACA,wBAAA;IACA,4BAAA;IACA,6BAAA;AACA;AAEA;IACA,YAAA;IACA,kBAAA;IACA,qBAAA;IACA,iBAAA;AACA;AAEA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,2BAAA;IACA,aAAA;IACA,sBAAA;IACA,yCAAA;IACA,+BAAA;IACA,gCAAA;AACA;AAEA;IACA,mBAAA;AACA;AAEA;IACA,gBAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;AACA;AAEA;IACA,8BAAA;AACA;AAEA;;IAEA,WAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;IACA,kCAAA;IACA,uBAAA;IACA,YAAA;AACA;AAEA;;IAEA,qBAAA;IACA,aAAA;AACA;AAEA;IACA,UAAA;IACA,YAAA;AACA;AAEA;IACA,kBAAA;AACA;AAEA;IACA,yBAAA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,kBAAA;IACA,eAAA;IACA,sCAAA;AACA;AAEA;IACA,yBAAA;AACA;AAEA;IACA,cAAA;IACA,kBAAA;IACA,eAAA;AACA;AAEA;IACA,aAAA;AACA;AAEA;IACA,yBAAA;IACA,cAAA;IACA,yBAAA;IACA,kBAAA;IACA,cAAA;IACA,aAAA;IACA,eAAA;IACA,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;AACA;AAEA;IACA,UAAA;AACA;AAEA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;IACA,sBAAA;AACA;AAEA;IACA,yBAAA;IACA,YAAA;IACA,qBAAA;AACA;AAEA;IACA,aAAA;IACA,mBAAA;AACA;AAEA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;AACA;AAEA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;AACA;AAEA;IACA,kBAAA;IACA,oBAAA;IACA,UAAA;IACA,eAAA;AACA;AAEA;AACA;QACA,wBAAA;AACA;AAEA;QACA,mBAAA;QACA,2BAAA;QACA,aAAA;AACA;AAEA;QACA,cAAA;AACA;AAEA;QACA,iBAAA;AACA;AACA","file":"Home.vue","sourcesContent":["<template>\n    <div v-if=\"error\"\n        style=\"display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top:10rem;\">\n        <img src=\"/assets/myinvois/images/Error Page Image.png\" alt=\"Logo\" style=\"width: 40rem; margin: 1rem;\" />\n        <div class=\"error-box\">\n            <p style=\"margin-bottom: 0;\">Invalid session link.<br>If you have any concern, please contact us at <span\n                    style=\"font-weight:bold;\"><a :href=\"`mailto:${support_email_address}`\">{{ support_email_address\n                        }}</a></span>\n            </p>\n        </div>\n    </div>\n    <div v-else>\n        <div class=\"header-container\">\n            <img :src=\"logo_file_path\" alt=\"Logo\" style=\"width: 9rem; margin: 1rem;\" />\n            <h4>Complete Details for <br class=\"mobile-next\"> E-Invoicing Compliances\n            </h4>\n        </div>\n        <div class=\"form-container\">\n            <div style=\"background-color: #e4e4e4;\" class=\"rounded\" v-if=\"is_submitted\">\n                <div style=\"display: flex; justify-content: center; margin-top: 20px;\">\n                    <svg  width=\"40px\" height=\"40px\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path opacity=\"0.5\" d=\"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z\" fill=\"#008000\"/>\n                        <path d=\"M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z\" fill=\"#ffffff\"/>\n                    </svg>\n                </div>\n                <p style=\"text-align: center; font-size: 14px; font-weight: bold; justify-content: center; margin: 8px;\">\n                    Congratulations! Your E-Invoice Info has been successfully submitted.\n                </p>\n            </div>\n            <p></p>\n            <form @submit.prevent=\"submit_form\">\n\n                <div style=\"font-size: 18px; font-weight: bold; color:black; padding: 1rem 0 0 0;\">\n                    <span v-if=\"claim_as === 'Company'\">COMPANY DETAILS</span>\n                    <span v-else>INDIVIDUAL DETAILS</span>\n                </div>\n                <hr class=\"title-line\">\n\n                <!-- NRIC and Name fields for Individual -->\n                <div v-if=\"claim_as === 'Individual'\" class=\"form-group\">\n                    <label for=\"identification_number_type\" style=\"margin-bottom: 1rem;\">\n                        Identification Number Type\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <div class=\"identification-number-row\">\n                        <div v-for=\"identification_number_type in identification_number_type_options\"\n                            :key=\"identification_number_type\" class=\"form-check\">\n                            <input type=\"radio\" :id=\"identification_number_type\"\n                                v-model=\"formData.identification_number_type\" :value=\"identification_number_type\"\n                                required :disabled=\"is_submitted\" />\n                            <label :for=\"identification_number_type\" v-text=\"identification_number_type\"\n                                style=\"margin: 0 1rem 0 0;\">\n                            </label>\n                        </div>\n                    </div>\n                </div>\n\n                <div v-if=\"claim_as === 'Individual'\" class=\"form-group\">\n                    <input type=\"text\" pattern=\"[0-9]*\" v-model=\"formData.identification_number\"\n                        id=\"identification_number\" :placeholder=\"get_identification_number_placeholder\" required\n                        @keydown=\"handleKeydown\" @input=\"handleInput\" :disabled=\"is_submitted\" />\n                    <div class=\"form-error-msg\">\n                        <span v-if=\"form_error_data.identification_number\">{{\n                            form_error_data.identification_number }}</span>\n                    </div>\n\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"full_name\">\n                        <span v-if=\"claim_as === 'Company'\">Company Name</span>\n                        <span v-else>Full Name (as per ID)</span>\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label> <input type=\"text\" v-model=\"formData.full_name\" :disabled=\"is_submitted\" />\n                </div>\n\n                <!-- Business Email or Email Field -->\n                <div class=\"form-group\">\n                    <label for=\"email\">\n                        <span v-text=\"claim_as === 'Company' ? 'Company Email Address' : 'Email Address'\"></span>\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input type=\"email\" v-model=\"formData.email\" id=\"email-field\"\n                        :placeholder=\"claim_as === 'Company' ? 'company@domain.com' : 'email@domain.com'\"\n                        :disabled=\"is_submitted\" />\n                    <div class=\"form-error-msg\">\n                        <span v-if=\"form_error_data.email\">{{ form_error_data.email }}</span>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"contact_number\">\n                        <span v-text=\"claim_as === 'Company' ? 'Company Contact No.' : 'Contact No.'\"></span>\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input id=\"phone\" type=\"tel\" :disabled=\"is_submitted\" />\n                    <div class=\"form-error-msg\">\n                        <span v-if=\"form_error_data.phone\">{{ form_error_data.phone }}</span>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"tax_id\">\n                        <span\n                            v-text=\"claim_as === 'Company' ? 'Company Tax Identification No. (TIN)' : 'Tax Identification No. (TIN)'\"></span>\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input id=\"tax_id\" type=\"text\" v-model=\"formData.tax_id\" placeholder=\"Eg: CXX53644000\" required\n                        :disabled=\"is_submitted\"   @input=\"formData.tax_id = formData.tax_id.toUpperCase()\" />\n                    <div class=\"form-error-msg\">\n                        <span v-if=\"form_error_data.tax_id\">{{ form_error_data.tax_id }}</span>\n                    </div>\n                </div>\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"roc\">\n                        New Business Registration No. (ROC)\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input id=\"roc\" type=\"text\" v-model=\"formData.roc\" placeholder=\"Eg: 198301031144\" required\n                        :disabled=\"is_submitted\" @input=\"formData.roc = formData.roc.toUpperCase()\" />\n                    <div class=\"form-error-msg\">\n                        <span v-if=\"form_error_data.roc\">{{ form_error_data.roc }}</span>\n                    </div>\n                </div>\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"sst_number\">\n                        Sales and Services Tax (SST) Registration No.\n                        <span class=\"mandatory-label\">&nbsp;(Optional)</span>\n                    </label>\n                    <input id=\"sst_number\" type=\"text\" v-model=\"formData.sst_number\" placeholder=\"Eg: XXX8888888888XX\"\n                        :disabled=\"is_submitted\" @input=\"formData.sst_number = formData.sst_number.toUpperCase()\" />\n                    <div class=\"form-error-msg\">\n                        <span v-if=\"form_error_data.sst_number\">{{ form_error_data.sst_number }}</span>\n                    </div>\n                </div>\n\n                <div v-if=\"claim_as === 'Company' && is_supplier\" class=\"form-group\">\n                    <label for=\"msic_code\">\n                        MSIC Code\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <select v-model=\"formData.msic_code\" required :disabled=\"is_submitted\" id=\"msic-code-select-element\">\n                        <option v-for=\"msic_code, index in msic_options\" :key=\"index\" :value=\"msic_code.name\">\n                            {{ msic_code.name }} - {{ msic_code.description }}\n                        </option>\n                    </select>\n                </div>\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"fax_number\">\n                        Fax No.\n                        <span class=\"mandatory-label\">&nbsp;(Optional)</span>\n                    </label>\n                    <input type=\"text\" v-model=\"formData.fax_number\" placeholder=\"Eg: 123-456-7890\"\n                        :disabled=\"is_submitted\" />\n                </div>\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"operating_from_time\">\n                        Operating From Time\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input type=\"time\" v-model=\"formData.operating_from_time\" required :disabled=\"is_submitted\" />\n                </div>\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"operating_to_time\">\n                        Operating To Time\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input type=\"time\" v-model=\"formData.operating_to_time\" required :disabled=\"is_submitted\" />\n                </div>\n\n                <!-- Sales Representative Info Fields -->\n                <div v-if=\"claim_as === 'Company'\"\n                    style=\"font-size: 18px; font-weight: bold; color:black; padding: 1rem 0 0 0;\">\n                    <span>Sales Representative Info</span>\n                </div>\n                <hr v-if=\"claim_as === 'Company'\" class=\"title-line\">\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"sales_representative\">\n                        Sales Representative Name\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input type=\"text\" v-model=\"formData.sales_representative\" placeholder=\"Eg: John Doe\" required\n                        :disabled=\"is_submitted\" />\n                </div>\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"sales_representative_email\">\n                        Sales Representative Email\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input type=\"text\" v-model=\"formData.sales_representative_email\" id=\"sales_representative_email\"\n                        placeholder=\"Eg: john.doe@example.com\" required :disabled=\"is_submitted\" />\n                    <div class=\"form-error-msg\">\n                        <span v-if=\"form_error_data.sales_representative_email\">{{\n                            form_error_data.sales_representative_email }}</span>\n                    </div>\n                </div>\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"sales_representative_contact_number\">\n                        Sales Representative Contact No.\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input id=\"sales_representative_contact_number\" type=\"tel\" :disabled=\"is_submitted\" />\n                    <div class=\"form-error-msg\">\n                        <span v-if=\"form_error_data.sales_representative_contact_number\">{{\n                            form_error_data.sales_representative_contact_number }}</span>\n                    </div>\n                </div>\n\n                <!-- Accounts Receivable Representative Info Fields -->\n                <div v-if=\"claim_as === 'Company'\"\n                    style=\"font-size: 18px; font-weight: bold; color:black; padding: 1rem 0 0 0;\">\n                    <span>Accounts Receivable Representative Info</span>\n                </div>\n                <hr v-if=\"claim_as === 'Company'\" class=\"title-line\">\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"accounts_receivable_representative\">\n                        Accounts Receivable Representative Name\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input type=\"text\" v-model=\"formData.accounts_receivable_representative\" placeholder=\"Eg: Jane Doe\"\n                        required :disabled=\"is_submitted\" />\n                </div>\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"accounts_receivable_representative_email\">\n                        Accounts Receivable Representative Email\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input type=\"text\" v-model=\"formData.accounts_receivable_representative_email\"\n                        id=\"accounts_receivable_representative_email\" placeholder=\"Eg: jane.doe@example.com\" required\n                        :disabled=\"is_submitted\" />\n                    <div class=\"form-error-msg\">\n                        <span v-if=\"form_error_data.accounts_receivable_representative_email\">{{\n                            form_error_data.accounts_receivable_representative_email }}</span>\n                    </div>\n                </div>\n\n                <div v-if=\"claim_as === 'Company'\" class=\"form-group\">\n                    <label for=\"accounts_receivable_representative_contact_number\">\n                        Accounts Receivable Representative Contact No.\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input id=\"accounts_receivable_representative_contact_number\" type=\"tel\" :disabled=\"is_submitted\" />\n                    <div class=\"form-error-msg\">\n                        <span v-if=\"form_error_data.accounts_receivable_representative_contact_number\">{{\n                            form_error_data.accounts_receivable_representative_contact_number }}</span>\n                    </div>\n                </div>\n\n\n                <!-- Address Fields -->\n                <div style=\"font-size: 18px; font-weight: bold; color:black; padding: 1rem 0 0 0;\">\n                    <span v-text=\"claim_as === 'Company' ? 'COMPANY ADDRESS' : 'ADDRESS'\"></span>\n                </div>\n                <hr class=\"title-line\">\n\n                <div class=\"form-group\">\n                    <label for=\"address_line_1\">\n                        <span>Address Line 1</span>\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input type=\"text\" v-model=\"formData.address_line_1\" placeholder=\"NO 123, Jalan Besar\" required\n                        :disabled=\"is_submitted\" />\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"address_line_2\">\n                        <span>Address Line 2</span>\n                        <span class=\"mandatory-label\">&nbsp;(Optional)</span>\n                    </label>\n                    <input type=\"text\" v-model=\"formData.address_line_2\"\n                        :placeholder=\"is_submitted ? '' : 'Apartment 5A'\" :disabled=\"is_submitted\" />\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"postcode\">\n                        <span>Postcode</span>\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input type=\"text\" v-model=\"formData.postcode\" placeholder=\"12345\" required\n                        :disabled=\"is_submitted\" />\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"country\">\n                        <span>Country</span>\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <select v-model=\"formData.country\" required :disabled=\"is_submitted\">\n                        <option v-for=\"country in country_options\" :key=\"country.name\" :value=\"country.name\">\n                            {{ country.name }}\n                        </option>\n                    </select>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"state\">\n                        <span>State</span>\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <select v-model=\"formData.state_code\" required\n                        :disabled=\"is_submitted || formData.country != 'Malaysia'\">\n                        <option v-for=\"state_code in filtered_state_options\" :key=\"state_code.name\"\n                            :value=\"state_code.name\">\n                            {{ state_code.name }} - {{ state_code.state }}\n                        </option>\n                    </select>\n                </div>\n\n                <div class=\"form-group\">\n                    <label for=\"city\">\n                        <span>City</span>\n                        <span class=\"mandatory-label\">&nbsp;*</span>\n                    </label>\n                    <input v-if=\"formData.country != 'Malaysia'\" type=\"text\" v-model=\"formData.city\"\n                        placeholder=\"Enter city\" required :disabled=\"is_submitted\" />\n                    <select v-else-if=\"formData.state_code\" v-model=\"formData.city\" required :disabled=\"is_submitted\">\n                        <option v-for=\"(city, index) in set_cities(formData.state_code)\" :key=\"index\" :value=\"city\">\n                            {{ city }}\n                        </option>\n                    </select>\n                    <select v-else>\n                        <option disabled>Please Choose State First</option>\n                    </select>\n                </div>\n\n                <div class=\"form-actions\">\n                    <button type=\"submit\" class=\"btn-primary\" :class=\"{ 'btn-success': is_submitted }\"\n                        :disabled=\"is_submitting || is_submitted\" style=\"border-radius: 2rem; font-weight: bold;\">\n                        {{ is_submitted ? \"Submitted\" : (is_submitting ? \"Submitting...\" : \"Submit\") }}\n                    </button>\n                </div>\n            </form>\n            <div style=\"text-align: center; margin-top: 2rem; color: #398bff; font-size: 14px;\">\n                Powered by <a :href=\"`https://www.byondwave.com/`\" target=\"_blank\" style=\"color: #398bff;\">BYONDWAVE.com</a>\n            </div>\n        </div>\n    </div>\n</template>\n\n<script>\nimport { getCities } from \"malaysia-postcodes\";\nimport SlimSelect from 'slim-select'\n\nexport default {\n    props: [\"frm\", \"session_id_prop\"],\n    data() {\n        return {\n            session_id: this.session_id_prop,\n            error: false,\n            support_email_address: \"\",\n            logo_file_path: \"\",\n            formData: {\n                doctype: '',\n                name: '',\n                full_name: '',\n                email: '',\n                contact_number: '',\n                country_iso2: '',\n                identification_number_type: 'MyKad',\n                identification_number: '',\n                tax_id: '',\n                roc: '',\n                sst_number: '',\n                msic_code: '',\n                fax_number: '',\n                operating_from_time: '',\n                operating_to_time: '',\n                sales_representative: '',\n                sales_representative_email: '',\n                sales_representative_contact_number: '',\n                sales_representative_country_iso2: '',\n                accounts_receivable_representative: '',\n                accounts_receivable_representative_email: '',\n                accounts_receivable_representative_contact_number: '',\n                accounts_receivable_representative_country_iso2: '',\n                address_line_1: '',\n                address_line_2: '',\n                postcode: '',\n                city: '',\n                state_code: '',\n                country: 'Malaysia',\n                session_id: this.session_id,\n            },\n            state_options: [],\n            country_options: [],\n            msic_options: [],\n            slim_select_instance: null,\n            identification_number_type_options: [],\n            is_submitting: false,\n            is_submitted: false,\n            is_supplier: false,\n            claim_as: \"\",\n            phone_instance: null,\n            sales_representative_contact_number_instance: null,\n            accounts_receivable_representative_contact_number_instance: null,\n            form_error_data: {},\n        };\n    },\n    computed: {\n        filtered_state_options() {\n            // Filter out \"All State\" and \"Not Applicable\"\n            return this.state_options.filter(option =>\n                // option.state !== 'All States' && option.state !== 'Not Applicable'\n                option.name !== \"00\"\n            )\n        },\n        get_identification_number_placeholder() {\n            if (this.formData.identification_number_type === \"MyKad\") {\n                return \"Eg: 020712081223\";\n            } else if (this.formData.identification_number_type === \"Passport\") {\n                return \"Eg: A12345678\";\n            }\n            return \"Enter Identification Number\";\n        },\n    },\n    methods: {\n        get_profile() {\n            frappe.call({\n                method: \"myinvois.api.get_profile\",\n                args: {\n                    session_id: this.session_id,\n                },\n                callback: (response) => {\n                    if (response.success) {\n                        const response_info = response.message.customer_einvoice_info[0];\n\n                        this.identification_number_type_options = response.message.identification_number_type_options;\n                        if (response_info.customer) {\n                            this.formData.name = response_info.customer;\n                            this.claim_as = response_info.customer_type;\n                            this.formData.doctype = \"Customer\";\n                        } else if (response_info.supplier) {\n                            this.formData.name = response_info.supplier;\n                            this.claim_as = response_info.supplier_type;\n                            this.is_supplier = true;\n                            this.formData.doctype = \"Supplier\";\n                        }\n                        this.logo_file_path = response.message.logo_file_path;\n\n                        if (response_info.docstatus == 0) {\n                            this.formData.full_name = response_info.full_name;\n\n                            if (response_info.customer_type == \"Company\")\n                                this.formData.identification_number_type = \"\"\n\n                        } else if (response_info.docstatus == 1) {\n                            if (response_info.customer_type === \"Individual\" || response_info.supplier_type === \"Individual\") {\n                                this.formData.identification_number_type = response_info.identification_number_type;\n                                this.formData.identification_number = response_info.identification_number;\n\n                            } else if (response_info.customer_type === \"Company\" || response_info.supplier_type === \"Company\") {\n                                this.formData.roc = response_info.business_registration_of_company_number_roc;\n                                if (response_info.sales_and_services_tax_sst_registration_number == \"\") {\n                                    this.formData.sst_number = \" \"\n                                } else {\n                                    this.formData.sst_number = response_info.sales_and_services_tax_sst_registration_number;\n                                }\n                                this.formData.msic_code = response_info.msic_code;\n                                this.formData.fax_number = response_info.fax_number;\n                                this.formData.operating_from_time = this.set_time_format(response_info.operating_from_time);\n                                this.formData.operating_to_time = this.set_time_format(response_info.operating_to_time);\n\n                                this.formData.sales_representative = response_info.sales_representative;\n                                this.formData.sales_representative_email = response_info.sales_representative_email;\n                                this.formData.sales_representative_contact_number = response_info.sales_representative_contact_number;\n                                this.formData.accounts_receivable_representative = response_info.accounts_receivable_representative;\n                                this.formData.accounts_receivable_representative_email = response_info.accounts_receivable_representative_email;\n                                this.formData.accounts_receivable_representative_contact_number = response_info.accounts_receivable_representative_contact_number;\n\n                                const sales_representative_contact_number_country = this.sales_representative_contact_number_instance.getSelectedCountryData(response_info.sales_representative_country_iso2);\n                                const sales_representative_contact_number_dial_code = `+${sales_representative_contact_number_country.dialCode}`;\n                                const sales_representative_contact_number = document.querySelector(\"#sales_representative_contact_number\");\n                                sales_representative_contact_number.value = response_info.sales_representative_contact_number.slice(sales_representative_contact_number_dial_code.length);\n\n                                this.sales_representative_contact_number_instance.setCountry(response_info.sales_representative_country_iso2);\n\n                                const accounts_receivable_representative_contact_number_country = this.accounts_receivable_representative_contact_number_instance.getSelectedCountryData(response_info.accounts_receivable_representative_country_iso2);\n                                const accounts_receivable_representative_contact_number_dial_code = `+${accounts_receivable_representative_contact_number_country.dialCode}`;\n                                const accounts_receivable_representative_contact_number = document.querySelector(\"#accounts_receivable_representative_contact_number\");\n                                accounts_receivable_representative_contact_number.value = response_info.accounts_receivable_representative_contact_number.slice(accounts_receivable_representative_contact_number_dial_code.length);\n\n                                this.accounts_receivable_representative_contact_number_instance.setCountry(response_info.accounts_receivable_representative_country_iso2);\n                            }\n                            this.formData.full_name = response_info.full_name;\n                            this.formData.email = response_info.email;\n                            this.formData.contact_number = response_info.contact_number;\n\n                            this.phone_instance.setCountry(response_info.country_iso2);\n\n                            const country = this.phone_instance.getSelectedCountryData(response_info.country_iso2);\n                            const dial_code = `+${country.dialCode}`;\n                            const phone_input = document.querySelector(\"#phone\");\n                            phone_input.value = response_info.contact_number.slice(dial_code.length);\n\n                            this.phone_instance.setCountry(response_info.country_iso2);\n\n                            this.formData.tax_id = response_info.tax_id;\n                            this.formData.address_line_1 = response_info.address_line_1;\n                            this.formData.address_line_2 = response_info.address_line_2;\n                            this.formData.postcode = response_info.postcode;\n                            this.formData.city = response_info.city;\n                            this.formData.state_code = response_info.state_code;\n\n                            this.is_submitted = true;\n                        }\n                    } else {\n                        this.error = true;\n                        this.support_email_address = response.message.support_email_address;\n                    }\n                }\n            });\n        },\n        set_time_format(time_string) {\n            const [hours, minutes] = time_string.split(':').map((part) => parseInt(part, 10) || 0);\n\n            // Pad hours and minutes to always have two digits\n            const formatted_hours = hours.toString().padStart(2, '0');\n            const formatted_minutes = minutes.toString().padStart(2, '0');\n\n            return `${formatted_hours}:${formatted_minutes}`;\n        },\n        get_msic_codes() {\n            frappe.call({\n                method: \"myinvois.api.get_msic_codes\",\n                args: {},\n                callback: (response) => {\n                    if (response.message) {\n                        this.msic_options = response.message;\n                        this.$nextTick(() => {\n                            if (this.slim_select_instance) {\n                                this.slim_select_instance.destroy();\n                            }\n                            this.slim_select_instance = new SlimSelect({\n                                select: '#msic-code-select-element',\n                            });\n                        });\n                    }\n                }\n            });\n        },\n        get_country_and_state_codes() {\n            frappe.call({\n                method: \"myinvois.api.get_country_and_state_codes\",\n                args: {},\n                callback: (response) => {\n                    if (response.message) {\n                        this.state_options = response.message.state_codes;\n                        this.country_options = response.message.countries;\n                    }\n                }\n            });\n        },\n        set_cities(state) {\n            const matched_state = this.state_options.find(state_dict => state_dict.name === state)\n\n            if (matched_state.state === 'Wilayah Persekutuan Kuala Lumpur')\n                return [\"Kuala Lumpur\"]\n            else if (matched_state.state === 'Wilayah Persekutuan Labuan')\n                return [\"Labuan\"]\n            else if (matched_state.state === 'Pulau Pinang')\n                matched_state.state = \"Penang\";\n            else if (matched_state.state === 'Wilayah Persekutuan Putrajaya')\n                return [\"Putrajaya\"]\n            return getCities(matched_state.state)\n        },\n        validate_form() {\n            let isValid = true;\n            this.form_error_data = {}; // Clear previous errors\n\n            const form_container = document.querySelector(\".form-container\");\n            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$/;\n            const nricPattern = /^\\d{6}\\d{2}\\d{4}$/;\n            const passportPattern = /^[AHKahk]\\d{8}$/;\n            const taxIDPatternIndividual = /^(IG)(\\d{9,11})$/; // Individual TINs\n            const taxIDPatternCompany = /^[CDEF](\\d{9,11})(0?)$/;  // Non-Individual TINs\n\n            const rocPattern = /^\\d{4}(01|02|03|04|05|06)\\d{6}$/;\n            const sstRegNoPattern = /^[A-Z]\\d{2}\\d{4}\\d{8}$/;\n\n            const email_input = document.querySelector(\"#email-field\");\n            const sales_representative_email_input = document.querySelector(\"#sales_representative_email\")\n            const accounts_receivable_representative_email_input = document.querySelector(\"#accounts_receivable_representative_email\")\n\n            const phone_input = document.querySelector(\"#phone\");\n            const sales_representative_contact_number_input = document.querySelector(\"#sales_representative_contact_number\");\n            const accounts_receivable_representative_contact_number_input = document.querySelector(\"#accounts_receivable_representative_contact_number\");\n\n            const identification_number_input = document.querySelector(\"#identification_number\");\n            const tax_id_input = document.querySelector(\"#tax_id\");\n            const roc_input = document.querySelector(\"#roc\");\n            const sst_number_input = document.querySelector(\"#sst_number\");\n\n            const identification_number_patterns = {\n                'MyKad': nricPattern,\n                'Passport': passportPattern,\n            };\n\n            // if (!this.formData.tax_id || this.formData.tax_id === null || !taxIDPatternIndividual.test(this.formData.tax_id)) {\n            //     this.form_error_data.tax_id = \"Please enter a valid TIN.\";\n            //     isValid = false;\n            //     tax_id_input.style.borderColor = \"red\";\n            // } else {\n            //     tax_id_input.style.borderColor = \"\";\n            // }\n\n            // Email Validation\n            if (!this.formData.email || !emailPattern.test(this.formData.email)) {\n                this.form_error_data.email = \"Please enter a valid email address.\";\n                isValid = false;\n                email_input.style.borderColor = \"red\";\n            } else {\n                email_input.style.borderColor = \"\";\n            }\n\n            // Phone Validation\n            if (!this.phone_instance) {\n                if (!phone_input.value) {\n                    this.form_error_data.phone = \"Please enter a phone number.\";\n                    isValid = false;\n                    phone_input.style.borderColor = \"red\";\n                } else {\n                    phone_input.style.borderColor = \"\";\n                }\n\n            } else {\n                const isValidPhone = this.phone_instance.isValidNumber();\n                if (!isValidPhone) {\n                    this.form_error_data.phone = \"Please enter a valid phone number.\";\n                    isValid = false;\n                    phone_input.style.borderColor = \"red\";\n                } else {\n                    phone_input.style.borderColor = \"\";\n                }\n            }\n\n            if (this.claim_as == \"Individual\") {\n                if (this.formData.identification_number_type) {\n                    // Identification Number\n                    if (identification_number_input) {\n                        const value = this.formData.identification_number;\n                        const pattern = identification_number_patterns[this.formData.identification_number_type];\n                        if (!value || value === null || !pattern.test(value)) {\n                            this.form_error_data.identification_number = `Please enter a valid ${this.formData.identification_number_type} number.`;\n                            isValid = false;\n                            identification_number_input.style.borderColor = \"red\";\n                        } else {\n                            identification_number_input.style.borderColor = \"\";\n                        }\n                    }\n                }\n\n                if (!taxIDPatternIndividual.test(this.formData.tax_id)) {\n                    this.form_error_data.tax_id = \"Please enter a valid TIN for an Individual.\";\n                    isValid = false;\n                    tax_id_input.style.borderColor = \"red\";\n                } else {\n                    tax_id_input.style.borderColor = \"\";\n                }\n\n            } else if (this.claim_as == \"Company\") {\n                if (!taxIDPatternCompany.test(this.formData.tax_id)) {\n                    this.form_error_data.tax_id = \"Please enter a valid TIN for a Company.\";\n                    isValid = false;\n                    tax_id_input.style.borderColor = \"red\";\n                } else {\n                    tax_id_input.style.borderColor = \"\";\n                }\n\n                // Company ROC/BRN\n                if (!this.formData.roc || this.formData.roc === null || !rocPattern.test(this.formData.roc)) {\n                    this.form_error_data.roc = \"Please enter a valid ROC.\";\n                    isValid = false;\n                    roc_input.style.borderColor = \"red\";\n                } else {\n                    roc_input.style.borderColor = \"\";\n                }\n\n                // SST Registration No\n                if (this.formData.sst_number != \"\" && !sstRegNoPattern.test(this.formData.sst_number)) {\n                    this.form_error_data.sst_number = \"Please enter a valid SST Registration No.\";\n                    isValid = false;\n                    sst_number_input.style.borderColor = \"red\";\n                } else {\n                    sst_number_input.style.borderColor = \"\";\n                }\n\n                // Sales Representative Email Validation\n                if (!this.formData.sales_representative_email || !emailPattern.test(this.formData.sales_representative_email)) {\n                    this.form_error_data.sales_representative_email = \"Please enter a valid email address.\";\n                    isValid = false;\n                    sales_representative_email_input.style.borderColor = \"red\";\n                } else {\n                    sales_representative_email_input.style.borderColor = \"\";\n                }\n\n                // Sales Representative Contact Number Validation\n                if (!this.sales_representative_contact_number_instance) {\n                    if (!sales_representative_contact_number_input.value) {\n                        this.form_error_data.sales_representative_contact_number = \"Please enter a contact number.\";\n                        isValid = false;\n                        sales_representative_contact_number_input.style.borderColor = \"red\";\n                    } else {\n                        sales_representative_contact_number_input.style.borderColor = \"\";\n                    }\n                } else {\n                    const isValidSalesPhone = this.sales_representative_contact_number_instance.isValidNumber();\n                    if (!isValidSalesPhone) {\n                        this.form_error_data.sales_representative_contact_number = \"Please enter a valid contact number.\";\n                        isValid = false;\n                        sales_representative_contact_number_input.style.borderColor = \"red\";\n                    } else {\n                        sales_representative_contact_number_input.style.borderColor = \"\";\n                    }\n                }\n\n                // Account Receivable Representative Email Validation\n                if (!this.formData.accounts_receivable_representative_email || !emailPattern.test(this.formData.accounts_receivable_representative_email)) {\n                    this.form_error_data.accounts_receivable_representative_email = \"Please enter a valid email address.\";\n                    isValid = false;\n                    accounts_receivable_representative_email_input.style.borderColor = \"red\";\n                } else {\n                    accounts_receivable_representative_email_input.style.borderColor = \"\";\n                }\n\n                // Account Receivable Representative Contact Number Validation\n                if (!this.accounts_receivable_representative_contact_number_instance) {\n                    if (!accounts_receivable_representative_contact_number_input.value) {\n                        this.form_error_data.accounts_receivable_representative_contact_number = \"Please enter an contact number.\";\n                        isValid = false;\n                        accounts_receivable_representative_contact_number_input.style.borderColor = \"red\";\n                    } else {\n                        accounts_receivable_representative_contact_number_input.style.borderColor = \"\";\n                    }\n                } else {\n                    const isValidAccountPhone = this.accounts_receivable_representative_contact_number_instance.isValidNumber();\n                    if (!isValidAccountPhone) {\n                        this.form_error_data.accounts_receivable_representative_contact_number = \"Please enter a valid contact number.\";\n                        isValid = false;\n                        accounts_receivable_representative_contact_number_input.style.borderColor = \"red\";\n                    } else {\n                        accounts_receivable_representative_contact_number_input.style.borderColor = \"\";\n                    }\n                }\n            }\n            if (!isValid) {\n                form_container.style.border = \"2px solid red\";\n            } else {\n                form_container.style.border = \"\"\n            }\n\n            return isValid;\n        },\n        init_phone_input() {\n            const phone_input = document.querySelector(\"#phone\");\n            const sales_representative_contact_number = document.querySelector(\"#sales_representative_contact_number\");\n            const accounts_receivable_representative_contact_number = document.querySelector(\"#accounts_receivable_representative_contact_number\");\n\n            if (phone_input) {\n                this.phone_instance = intlTelInput(phone_input, {\n                    initialCountry: \"my\",\n                    loadUtils: () => import(\"https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js\"),\n                    separateDialCode: true,\n                    useFullscreenPopup: false,\n                    autoPlaceholder: \"aggressive\",\n                    validationNumberTypes: [\"FIXED_LINE_OR_MOBILE\"]\n                });\n\n                phone_input.addEventListener(\"input\", () => this.update_phone_number(\"phone\"));\n                phone_input.addEventListener(\"countrychange\", () => this.update_phone_number(\"phone\"));\n            }\n\n            if (sales_representative_contact_number) {\n                this.sales_representative_contact_number_instance = intlTelInput(sales_representative_contact_number, {\n                    initialCountry: \"my\",\n                    loadUtils: () => import(\"https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js\"),\n                    separateDialCode: true,\n                    useFullscreenPopup: false,\n                    autoPlaceholder: \"aggressive\",\n                    validationNumberTypes: [\"FIXED_LINE_OR_MOBILE\"]\n                });\n                sales_representative_contact_number.addEventListener(\"input\", () => this.update_phone_number(\"sales_phone\"));\n                sales_representative_contact_number.addEventListener(\"countrychange\", () => this.update_phone_number(\"sales_phone\"));\n            }\n\n            if (accounts_receivable_representative_contact_number) {\n                this.accounts_receivable_representative_contact_number_instance = intlTelInput(accounts_receivable_representative_contact_number, {\n                    initialCountry: \"my\",\n                    loadUtils: () => import(\"https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js\"),\n                    separateDialCode: true,\n                    useFullscreenPopup: false,\n                    autoPlaceholder: \"aggressive\",\n                    validationNumberTypes: [\"FIXED_LINE_OR_MOBILE\"]\n                });\n                accounts_receivable_representative_contact_number.addEventListener(\"input\", () => this.update_phone_number(\"account_phone\"));\n                accounts_receivable_representative_contact_number.addEventListener(\"countrychange\", () => this.update_phone_number(\"account_phone\"));\n            }\n        },\n        update_phone_number(type) {\n            if (type === \"phone\" && this.phone_instance) {\n                const formatted_number = this.phone_instance.getNumber();\n                const country_iso2 = this.phone_instance.getSelectedCountryData().iso2;\n                const is_valid = this.phone_instance.isValidNumber();\n\n                if (is_valid !== false) {\n                    this.formData.contact_number = formatted_number;\n                    this.formData.country_iso2 = country_iso2;\n                }\n            } else if (type === \"sales_phone\" && this.sales_representative_contact_number_instance) {\n                const formatted_number = this.sales_representative_contact_number_instance.getNumber();\n                const sales_representative_country_iso2 = this.sales_representative_contact_number_instance.getSelectedCountryData().iso2;\n                const is_valid = this.sales_representative_contact_number_instance.isValidNumber();\n\n                if (is_valid !== false) {\n                    this.formData.sales_representative_contact_number = formatted_number;\n                    this.formData.sales_representative_country_iso2 = sales_representative_country_iso2;\n                }\n            } else if (type === \"account_phone\" && this.accounts_receivable_representative_contact_number_instance) {\n                const formatted_number = this.accounts_receivable_representative_contact_number_instance.getNumber();\n                const accounts_receivable_representative_country_iso2 = this.accounts_receivable_representative_contact_number_instance.getSelectedCountryData().iso2;\n                const is_valid = this.accounts_receivable_representative_contact_number_instance.isValidNumber();\n\n                if (is_valid !== false) {\n                    this.formData.accounts_receivable_representative_contact_number = formatted_number;\n                    this.formData.accounts_receivable_representative_country_iso2 = accounts_receivable_representative_country_iso2;\n                }\n            }\n        },\n        submit_form() {\n            if (this.is_submitting || this.is_submitted)\n                return;\n\n            const isValid = this.validate_form();\n            if (!isValid)\n                return;\n\n            this.update_phone_number();\n\n            this.is_submitting = true;\n            frappe.call({\n                method: \"myinvois.api.submit_profile\",\n                args: { formData: this.formData },\n                callback: (response) => {\n                    this.is_submitting = false;\n\n                    if (response.success) {\n                        this.is_submitted = true;\n                        frappe.show_alert({\n                            title: \"Success\",\n                            indicator: \"green\",\n                            message: \"Data submitted successfully.\",\n                        });\n                    } else {\n                        frappe.msgprint({\n                            title: \"Invalid\",\n                            indicator: \"red\",\n                            message: response.message,\n                        });\n                    }\n                },\n                error: () => {\n                    this.is_submitting = false;\n                },\n            });\n        },\n        handleKeydown(event) {\n            const allowedKeyCodes = [\n                48, 49, 50, 51, 52, 53, 54, 55, 56, 57, // Regular digits (0-9)\n                96, 97, 98, 99, 100, 101, 102, 103, 104, 105, // Numpad digits (0-9)\n                13, // Enter key\n                8, // Backspace key\n                9, // Tab key\n                37, // Left arrow key\n                39, // Right arrow key\n                46, // Delete key\n                65, // Ctrl+A\n                88, // Ctrl+X\n                67, // Ctrl+C\n                86 // Ctrl+V\n            ];\n\n            if (event.type === 'keydown') {\n                if (\n                    allowedKeyCodes.includes(event.keyCode) ||\n                    (event.ctrlKey && [\"a\", \"x\", \"c\", \"v\"].includes(event.key))\n                ) {\n                    return true;\n                } else {\n                    event.preventDefault();\n                    return false;\n                }\n            }\n        },\n        handleInput(event) {\n            const inputValue = event.target.value;\n            const sanitizedValue = inputValue.replace(/[^0-9]/g, '');\n            this.formData.identification_number = sanitizedValue;\n\n            event.target.value = sanitizedValue;\n        },\n    },\n    watch: {\n        'formData.identification_number_type'(new_value, old_value) {\n            if (new_value !== old_value) {\n                this.formData.identification_number = '';\n            }\n        },\n        \"formData.country\"(new_country) {\n            if (new_country !== \"Malaysia\") {\n                this.formData.state_code = \"17\";\n                this.formData.city = null;\n            } else {\n                this.formData.state_code = null;\n                this.formData.city = null;\n            }\n        },\n        claim_as(newValue) {\n            if (newValue === \"Company\") {\n                this.$nextTick(() => {\n                    this.init_phone_input();\n                    this.get_profile();\n                });\n            }\n        }\n    },\n    mounted() {\n        this.$nextTick(() => {\n            this.get_profile();\n            this.init_phone_input();\n            this.get_msic_codes();\n            this.get_country_and_state_codes();\n        });\n    },\n    beforeUnmount() {\n        if (this.phone_instance) {\n            this.phone_instance.destroy();\n        }\n        if (this.sales_representative_contact_number_instance) {\n            this.sales_representative_contact_number_instance.destroy();\n        }\n        if (this.accounts_receivable_representative_contact_number_instance) {\n            this.accounts_receivable_representative_contact_number_instance.destroy();\n        }\n    }\n};\n</script>\n\n<style scoped>\n.header-container {\n    text-align: center;\n    background-color: #3663e6;\n    padding: 20px;\n    max-width: 500px;\n    margin: 3rem auto 0 auto;\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n}\n\nh4 {\n    color: white;\n    margin-top: 1.2rem;\n    margin-bottom: 0.5rem;\n    font-weight: bold;\n}\n\n.form-container {\n    background: white;\n    padding: 20px 50px;\n    max-width: 500px;\n    margin: 0rem auto 3rem auto;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    border-bottom-left-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\nlabel {\n    font-weight: 600;\n    display: block;\n    margin-bottom: 8px;\n    color: #555;\n}\n\ninput {\n    border-radius: 10px !important;\n}\n\ninput,\nselect {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    font-size: 14px;\n    transition: border-color 0.2s ease;\n    background-color: white;\n    color: black;\n}\n\ninput:focus,\nselect:focus {\n    border-color: #007bff;\n    outline: none;\n}\n\ninput[type=radio] {\n    padding: 0;\n    border: none;\n}\n\n.form-actions {\n    text-align: center;\n}\n\n.btn-primary {\n    background-color: #007bff;\n    border: none;\n    color: white;\n    padding: 10px 20px;\n    font-size: 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.btn-primary:hover {\n    background-color: #0056b3;\n}\n\n.example-text {\n    color: #93999c;\n    margin-bottom: 5px;\n    font-size: 14px;\n}\n\n.mobile-next {\n    display: none;\n}\n\n.error-box {\n    background-color: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n    border-radius: 5px;\n    margin: 0 2rem;\n    padding: 20px;\n    font-size: 16px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.mandatory-label {\n    color: red;\n}\n\n.search-input {\n    margin-bottom: 10px;\n    width: 100%;\n    padding: 8px;\n    box-sizing: border-box;\n}\n\n.btn-success {\n    background-color: #28a745;\n    color: white;\n    border-color: #28a745;\n}\n\n.identification-number-row {\n    display: flex;\n    align-items: center;\n}\n\n.form-check {\n    padding: 0;\n    display: flex;\n    align-items: center;\n}\n\n.title-line {\n    border-width: 2px;\n    margin-top: 0.8rem;\n    background: black;\n}\n\n.form-error-msg {\n    margin-top: 0.3rem;\n    padding-left: 0.2rem;\n    color: red;\n    font-size: 14px;\n}\n\n@media (max-width: 575.99px) {\n    .header-container {\n        margin: 1rem 2rem 0 2rem;\n    }\n\n    .form-container {\n        font-size: 0.875rem;\n        margin: 0rem 2rem 1rem 2rem;\n        padding: 20px;\n    }\n\n    .mobile-next {\n        display: block;\n    }\n\n    h4 {\n        font-size: 1.5rem;\n    }\n}\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-1b940184"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../myinvois/myinvois/public/js/einvoice_profile/Home.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__